import axios from 'axios';
import resultsTemplate from './inputSearch.template.hbs';

/**
 * Input search
 * Javascript functionality for input search with live search results.
 * @version 3.0.0
 * @exports InputSearch
 */
export default class InputSearch {
	/**
	 * Constructor
	 * @param {Object} el - The form element as a DOM node.
	 * @public
	 */
	constructor(el) {
		/** The form DOM node for the search */
		this.formNode = el;

		/** The search input field */
		this.formInput = this.formNode.querySelector('input');

		/** Target id of results container */
		this.resultsTargetId = this.formNode.getAttribute('aria-controls');

		/** Container of search results */
		this.resultsContainer = this.formNode.querySelector(
			'#' + this.resultsTargetId
		);

		/** Loader within the results container */
		this.loader = this.formNode.querySelector('.loader');

		/** If request is in progress */
		this.requestInProgress = false;

		if (this.formNode) {
			this._init();
		}
	}

	/**
	 * The initialization function for this module.
	 * @private
	 */
	_init() {
		this._initEvents();
	}

	/**
	 * Triggers autocomplete search
	 * @param {String} value - The searched value
	 */
	_triggerAutocomplete(value) {
		const url = this.formNode.getAttribute('data-ajaxurl');
		const method = this.formNode.getAttribute('method') || 'GET';
		const name = this.formInput.getAttribute('name') || 'q';
		const lang = this.formNode.querySelector('#lang');

		if (this.requestInProgress === false) {
			this.requestInProgress = true;
			axios({
				url: `${url}?${name}=${value}&${(lang && lang.name) ||
					'lang'}=${(lang && lang.value) || 'sv'}`,
				method,
				headers: {
					'X-Requested-With': 'XMLHttpRequest',
				},
			})
				.then(response => {
					if (response.status === 200) {
						if (response.data.items.length > 0) {
							this._renderResults(response.data);
						}
					} else {
						alert('An error occured, try again later.');
					}
					this.requestInProgress = false;
					this.loader.classList.add('is-hidden');
				})
				.catch(e => {
					console.log(e);
					this.requestInProgress = false;
					this.loader.classList.add('is-hidden');
				});
		}
	}

	/**
	 * Renders results to
	 * @param {Object} results - The results from backend
	 */
	_renderResults(results) {
		const resultsHtml = resultsTemplate(results);
		this.resultsContainer.insertAdjacentHTML('BeforeEnd', resultsHtml);
	}

	/**
	 * Initiates mobile search events
	 */
	_initEvents() {
		const that = this;

		this.formInput.addEventListener('input', e => {
			setTimeout(() => {
				if (e.target.value.length > 2) {
					that.resultsContainer.classList.remove('is-hidden');
					that.resultsContainer.setAttribute('aria-hidden', false);
					that.formNode.setAttribute('aria-expanded', true);
					if (that.resultsContainer.querySelector('.article-list')) {
						that.resultsContainer.querySelector('.article-list').remove();
					}
					that.loader.classList.remove('is-hidden');

					that._triggerAutocomplete(e.target.value);
				} else {
					that.resultsContainer.querySelector('.article-list').remove();
					that.resultsContainer.classList.add('is-hidden');
					that.resultsContainer.setAttribute('aria-hidden', true);
					that.formNode.setAttribute('aria-expanded', false);
				}
			}, 700);
		});

		window.addEventListener('click', e => {
			if (!that.formNode.contains(e.target)) {
				that.resultsContainer.classList.add('is-hidden');
				that.resultsContainer.setAttribute('aria-hidden', true);
				that.formNode.setAttribute('aria-expanded', false);
			}
		});
	}
}
